// extracted by mini-css-extract-plugin
module.exports = {"header":"Index_header__-XbZL","profile-picture":"Index_profile-picture__FRxpY","button-list":"Index_button-list__1PlIc"};